var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ highlight: _vm.facility.isActive },on:{"click":function($event){return _vm.highlight()}}},[_vm._v("\n  "+_vm._s(_vm.facility.facilityname)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }